const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getOrgUsers(orgId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/users`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to view users');
    }
    throw new Error('Failed to fetch users');
  }
  
  const data = await response.json();
  return data.users;
}

export async function getOrgRoles(orgId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/roles`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch roles');
  }
  
  const data = await response.json();
  return data.roles;
}

export async function updateUserRole(orgId, userId, role) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/users/${userId}/roles`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify({ role })
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to modify user roles');
    }
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to update user role');
  }
  
  return response.json();
}
